import axios from 'axios';
import RestAPI from '../../components/Common/restApi';

class ViralApi {
  constructor() {
    this.authToken = null;
  }

  authenticate() {
    return new Promise((resolve, reject) => {
      if (this.authToken) {
        return resolve(this.authToken);
      }

      return this.getOAuthURL()
        .then((response) => RestAPI.get(response.data.url))
        .then((response) => response.data.token)
        .then(resolve)
        .catch(reject);
    }).then((token) => {
      this.authToken = token;
    });
  }

  getOAuthURL() {
    return RestAPI.get(`${VIRAL_ENGINE_URL}/auth/housecall_url`);
  }

  request(options) {
    const { method, path, body } = options;
    const url = `${VIRAL_ENGINE_URL}/${path}`;
    const headers = () => ({ authorization: `Token ${this.authToken}` });
    const doNetworkCall = () => {
      return axios({
        method: method,
        url: url,
        data: body,
        headers: headers(),
      });
    };

    return this.authenticate()
      .then(() => doNetworkCall())
      .catch((error) => {
        if (error.response.status === 401) {
          this.authToken = null;

          return this.authenticate().then(() => doNetworkCall());
        } else {
          throw error;
        }
      });
  }

  post(path, body) {
    return this.request({
      method: 'POST',
      path: path,
      body: body,
    });
  }
}

const ViralApiInstance = new ViralApi();

export default ViralApiInstance;
